import { TextField } from "@mui/material";
import { useMemo } from "react";
import API from "../../../services/API";

export default function Notion({value, onChange}){

    const handleChange = e => {
        const url = e.target.value.replaceAll(' ', '');

        const id = extractNotionPageID(url)

        const newValue = {id , url}

        return onChange(newValue);
    }

    const error = useMemo(() => value?.id === null, [value])

    return <>
    
        <TextField 
            type="url"
            label="Lien de la page Notion"
            value={value?.url || ""}
            onChange={handleChange}
            required
            size="small"
            error={error ? true : false}
            helperText={error ? "URL non valide" : "La page Notion doit être publiée sur le web"}
        />

        {value?.id &&

            <iframe
                title="Page Notion"
                src={API.url(`/notion/${value.id}/page.html`)}
                width={"100%"}
                height={400}
                frameBorder={0}
                style={{border: 'solid 1px lightgrey', padding: '0px 5px', borderRadius: '4px'}}
            >
                Page Notion introuvable
            </iframe>
        }

    </>
}

function extractNotionPageID(url) {
    return url.split('?')[0].split('/').pop().split('-').pop();
}